import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IFloating} from './getFloatings'

export const getFloatingItem = async (id): Promise<ApiRes<IFloating>> => {
    return await apiGet(API_URL, `admin/floating/message/${id}`)
}
